import "./WholePage.css";
import Form from "./Form";
import Info from "./Info";
export default function WholePage() {
  return (
      <div className="page">
      <Form />
      <Info/>
      </div>
  );
}
